/**
 * 首页路由判定：仅这些路径会延后非关键 SDK / vipcode。
 * 其它页（含 /company/）保持现网即时加载。
 */
export const isHomeRoute = (route: {
  name?: string | symbol | null
  path?: string
}) => {
  if (route.name === 'Home') return true
  const raw = route.path || '/'
  const path = raw.replace(/\/+$/, '') || '/'
  return path === '/' || path === '/cn' || path === '/en'
}

/** layout afterEach 只挂一次 */
let vipcodeRouteHooked = false
export const ensureVipcodeRouteHook = (
  router: { afterEach: (guard: (to: any, from: any) => void) => void },
  ensureVipcodeCss: () => unknown,
) => {
  if (!import.meta.client || vipcodeRouteHooked) return
  vipcodeRouteHooked = true
  router.afterEach((to, from) => {
    if (!isHomeRoute(from) || isHomeRoute(to)) return
    ensureVipcodeCss()
  })
}

/** app.vue：离开首页补齐埋点，只挂一次 */
let homeSdkRouteHooked = false
export const ensureHomeSdkRouteHook = (
  router: { afterEach: (guard: (to: any, from: any) => void) => void },
  ensureHomeDeferredReady: () => void,
) => {
  if (!import.meta.client || homeSdkRouteHooked) return
  homeSdkRouteHooked = true
  router.afterEach((to, from) => {
    if (!isHomeRoute(from) || isHomeRoute(to)) return
    ensureHomeDeferredReady()
  })
}

/** 离开首页立刻补全量 Vant，避免名录 FOUC */
let vantRouteHooked = false
export const ensureVantRouteHook = (
  router: { afterEach: (guard: (to: any, from: any) => void) => void },
  ensureFullVantCss: () => unknown,
) => {
  if (!import.meta.client || vantRouteHooked) return
  vantRouteHooked = true
  router.afterEach((to, from) => {
    if (!isHomeRoute(from) || isHomeRoute(to)) return
    ensureFullVantCss()
  })
}
